module.exports = __webpack_public_path__ + "assets/yandexmetrika.2417c5e4.svg";